module.exports = __webpack_public_path__ + "media/VIDEO GIF NQA WEB.8728a2e3.mp4";